import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { routes, isPublicRoute } from '../config';
import type { Customer, FirebaseUser } from '../types';

interface AuthGuardProps {
  children: ReactNode;
  currentUser: Customer | null;
  firebaseUser: FirebaseUser | null;
}

export default function AuthGuard({ children, currentUser, firebaseUser }: AuthGuardProps) {
  const location = useLocation();

  // Check if user is fully authenticated (has both Firebase auth and customer data)
  const isFullyAuthenticated = currentUser && firebaseUser && firebaseUser.uid;
  
  // Check if user has Firebase auth but no customer data (needs to register)
  const hasFirebaseAuthOnly = firebaseUser && firebaseUser.uid && !currentUser;
  console.log('firebaseUser ', firebaseUser, currentUser)
  // If not fully authenticated, redirect appropriately
  if (!isFullyAuthenticated) {
    // Save the attempted URL to redirect back after login
    const currentPath = location.pathname;
    if (!isPublicRoute(currentPath)) {
      // Store the attempted path in sessionStorage for redirect after login
      sessionStorage.setItem('redirectAfterLogin', currentPath);
    }
    if (hasFirebaseAuthOnly) {
      // User has Firebase auth but no customer data - redirect to register
      return <Navigate to={routes.register} replace />;
    } else {
      // User is not authenticated at all - redirect to login
      console.log("AuthGuard: User not authenticated, redirecting to login");
      return <Navigate to={routes.login} replace />;
    }
  }

  // If fully authenticated, render the children
  return <>{children}</>;
} 